import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceHighlights = ({ currentLanguage }) => {
  const content = {
    en: {
      title: "Why Choose Phangan Taxi",
      services: [
        {
          icon: "Clock",
          title: "24/7 Availability",
          description: "Round-the-clock service for all your transportation needs, day or night"
        },
        {
          icon: "DollarSign",
          title: "Fixed Pricing",
          description: "Transparent, upfront pricing with no hidden fees or surge charges"
        },
        {
          icon: "MessageCircle",
          title: "Multi-Contact Options",
          description: "Book via WhatsApp, Telegram, or phone call - choose your preferred method"
        },
        {
          icon: "Shield",
          title: "Licensed Drivers",
          description: "Professional, certified drivers who know the island inside out"
        },
        {
          icon: "MapPin",
          title: "Island-Wide Coverage",
          description: "Service to all major destinations across Koh Phangan"
        },
        {
          icon: "Languages",
          title: "Multi-Language Support",
          description: "Communicate in multiple languages for your convenience"
        }
      ]
    },
    ru: {
      title: "Почему Выбирают Phangan Taxi",
      services: [
        {
          icon: "Clock",
          title: "Доступность 24/7",
          description: "Круглосуточное обслуживание для всех ваших транспортных потребностей"
        },
        {
          icon: "DollarSign",
          title: "Фиксированные Цены",
          description: "Прозрачные цены без скрытых комиссий и повышающих коэффициентов"
        },
        {
          icon: "MessageCircle",
          title: "Множество Способов Связи",
          description: "Бронируйте через WhatsApp, Telegram или телефон - выберите удобный способ"
        },
        {
          icon: "Shield",
          title: "Лицензированные Водители",
          description: "Профессиональные сертифицированные водители, знающие остров как свои пять пальцев"
        },
        {
          icon: "MapPin",
          title: "Покрытие Всего Острова",
          description: "Обслуживание всех основных направлений на Ко Пангане"
        },
        {
          icon: "Languages",
          title: "Многоязычная Поддержка",
          description: "Общайтесь на нескольких языках для вашего удобства"
        }
      ]
    },
    th: {
      title: "ทำไมต้องเลือก Phangan Taxi",
      services: [
        {
          icon: "Clock",
          title: "บริการตลอด 24 ชั่วโมง",
          description: "บริการตลอดเวลาสำหรับความต้องการการเดินทางของคุณ ทั้งกลางวันและกลางคืน"
        },
        {
          icon: "DollarSign",
          title: "ราคาคงที่",
          description: "ราคาโปร่งใส ไม่มีค่าธรรมเนียมแอบแฝงหรือค่าบริการเพิ่มเติม"
        },
        {
          icon: "MessageCircle",
          title: "ช่องทางติดต่อหลากหลาย",
          description: "จองผ่าน WhatsApp, Telegram หรือโทรศัพท์ - เลือกวิธีที่คุณสะดวก"
        },
        {
          icon: "Shield",
          title: "คนขับที่ได้รับใบอนุญาต",
          description: "คนขับมืออาชีพที่ได้รับการรับรองและรู้จักเกาะเป็นอย่างดี"
        },
        {
          icon: "MapPin",
          title: "ครอบคลุมทั่วเกาะ",
          description: "บริการไปยังจุดหมายปลายทางหลักทั่วเกาะพะงัน"
        },
        {
          icon: "Languages",
          title: "รองรับหลายภาษา",
          description: "สื่อสารได้หลายภาษาเพื่อความสะดวกของคุณ"
        }
      ]
    },
    de: {
      title: "Warum Phangan Taxi Wählen",
      services: [
        {
          icon: "Clock",
          title: "24/7 Verfügbarkeit",
          description: "Rund-um-die-Uhr-Service für alle Ihre Transportbedürfnisse, Tag und Nacht"
        },
        {
          icon: "DollarSign",
          title: "Festpreise",
          description: "Transparente, vorab festgelegte Preise ohne versteckte Gebühren"
        },
        {
          icon: "MessageCircle",
          title: "Mehrere Kontaktoptionen",
          description: "Buchen Sie über WhatsApp, Telegram oder Telefonanruf - wählen Sie Ihre bevorzugte Methode"
        },
        {
          icon: "Shield",
          title: "Lizenzierte Fahrer",
          description: "Professionelle, zertifizierte Fahrer, die die Insel in- und auswendig kennen"
        },
        {
          icon: "MapPin",
          title: "Inselweite Abdeckung",
          description: "Service zu allen wichtigen Zielen auf Koh Phangan"
        },
        {
          icon: "Languages",
          title: "Mehrsprachiger Support",
          description: "Kommunizieren Sie in mehreren Sprachen für Ihre Bequemlichkeit"
        }
      ]
    },
    fr: {
      title: "Pourquoi Choisir Phangan Taxi",
      services: [
        {
          icon: "Clock",
          title: "Disponibilité 24h/24 et 7j/7",
          description: "Service 24 heures sur 24 pour tous vos besoins de transport, jour et nuit"
        },
        {
          icon: "DollarSign",
          title: "Tarifs Fixes",
          description: "Tarifs transparents et préétablis sans frais cachés"
        },
        {
          icon: "MessageCircle",
          title: "Options de Contact Multiples",
          description: "Réservez via WhatsApp, Telegram ou par téléphone - choisissez votre méthode préférée"
        },
        {
          icon: "Shield",
          title: "Chauffeurs Agréés",
          description: "Chauffeurs professionnels et certifiés qui connaissent l'île sur le bout des doigts"
        },
        {
          icon: "MapPin",
          title: "Couverture de Toute l\'Île",
          description: "Service vers toutes les principales destinations de Koh Phangan"
        },
        {
          icon: "Languages",
          title: "Support Multilingue",
          description: "Communiquez dans plusieurs langues pour votre commodité"
        }
      ]
    },
    zh: {
      title: "为什么选择帕岸出租车",
      services: [
        {
          icon: "Clock",
          title: "全天候服务",
          description: "全天候服务满足您的所有交通需求，无论白天还是夜晚"
        },
        {
          icon: "DollarSign",
          title: "固定价格",
          description: "透明、预先确定的价格，无隐藏费用或附加费"
        },
        {
          icon: "MessageCircle",
          title: "多种联系方式",
          description: "通过WhatsApp、Telegram或电话预订 - 选择您喜欢的方式"
        },
        {
          icon: "Shield",
          title: "持证司机",
          description: "专业认证的司机，对岛屿了如指掌"
        },
        {
          icon: "MapPin",
          title: "全岛覆盖",
          description: "服务覆盖帕岸岛所有主要目的地"
        },
        {
          icon: "Languages",
          title: "多语言支持",
          description: "支持多种语言交流，方便您使用"
        }
      ]
    },
    es: {
      title: "Por Qué Elegir Phangan Taxi",
      services: [
        {
          icon: "Clock",
          title: "Disponibilidad 24/7",
          description: "Servicio las 24 horas para todas sus necesidades de transporte, día y noche"
        },
        {
          icon: "DollarSign",
          title: "Precios Fijos",
          description: "Precios transparentes y por adelantado sin cargos ocultos"
        },
        {
          icon: "MessageCircle",
          title: "Múltiples Opciones de Contacto",
          description: "Reserve por WhatsApp, Telegram o llamada telefónica - elija su método preferido"
        },
        {
          icon: "Shield",
          title: "Conductores Licenciados",
          description: "Conductores profesionales y certificados que conocen la isla al dedillo"
        },
        {
          icon: "MapPin",
          title: "Cobertura en Toda la Isla",
          description: "Servicio a todos los destinos principales de Koh Phangan"
        },
        {
          icon: "Languages",
          title: "Soporte Multilingüe",
          description: "Comuníquese en varios idiomas para su comodidad"
        }
      ]
    },
    ja: {
      title: "パンガンタクシーを選ぶ理由",
      services: [
        {
          icon: "Clock",
          title: "24時間365日利用可能",
          description: "昼夜を問わず、すべての交通ニーズに対応する24時間体制のサービス"
        },
        {
          icon: "DollarSign",
          title: "固定料金",
          description: "隠れた料金や追加料金のない透明で事前確定の料金"
        },
        {
          icon: "MessageCircle",
          title: "複数の連絡オプション",
          description: "WhatsApp、Telegram、または電話で予約 - お好みの方法を選択してください"
        },
        {
          icon: "Shield",
          title: "ライセンス所持ドライバー",
          description: "島を隅々まで知り尽くしたプロの認定ドライバー"
        },
        {
          icon: "MapPin",
          title: "島全域をカバー",
          description: "パンガン島の主要な目的地すべてへのサービス"
        },
        {
          icon: "Languages",
          title: "多言語サポート",
          description: "お客様の便宜のために複数の言語で通信可能"
        }
      ]
    },
    ko: {
      title: "파간 택시를 선택하는 이유",
      services: [
        {
          icon: "Clock",
          title: "연중무휴 24시간",
          description: "낮이든 밤이든 모든 교통 수요에 대응하는 24시간 서비스"
        },
        {
          icon: "DollarSign",
          title: "고정 가격",
          description: "숨겨진 요금이나 추가 요금 없는 투명하고 미리 정해진 가격"
        },
        {
          icon: "MessageCircle",
          title: "다양한 연락 옵션",
          description: "WhatsApp, Telegram 또는 전화로 예약 - 선호하는 방법을 선택하세요"
        },
        {
          icon: "Shield",
          title: "면허 소지 운전자",
          description: "섬을 속속들이 아는 전문 인증 운전자"
        },
        {
          icon: "MapPin",
          title: "섬 전역 커버리지",
          description: "코팡안 섬의 모든 주요 목적지로 서비스 제공"
        },
        {
          icon: "Languages",
          title: "다국어 지원",
          description: "편의를 위해 여러 언어로 소통 가능"
        }
      ]
    }
  };

  const currentContent = content?.[currentLanguage] || content?.en;

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-secondary">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-foreground mb-12 sm:mb-16">
          {currentContent?.title}
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {currentContent?.services?.map((service, index) => (
            <div
              key={index}
              className="morphic-card p-6 sm:p-8 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-16 h-16 bg-accent/20 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-accent/30 transition-colors duration-300">
                <Icon name={service?.icon} size={32} color="var(--color-accent)" />
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-foreground mb-3">
                {service?.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {service?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceHighlights;